module.exports = __webpack_public_path__ + "static/media/lumppu___tenunenu.c48a5a0a.png";